import { useTranslation } from 'react-i18next';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { keyframes } from '@emotion/react';

import { AppleStoreIcon } from './icons/AppleStoreIcon';
import { ArrowIcon } from './icons/ArrowIcon';
import { GoogleStoreIcon } from './icons/GoogleStoreIcon';
import { QerkoLogoIcon } from './icons/QerkoLogoIcon';

import type { OS } from 'src/shared/types';

const bouncing = keyframes`
  from {
    transform: translate3d(0,1em,0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
`;

export const SmartBanner = ({ os, isBrowserSafari, urlIosStore }: { os: OS | undefined; isBrowserSafari: boolean; urlIosStore?: string }) => {
    const { t } = useTranslation('restaurantAdmin.smart.banner');

    return (
        <>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <Box sx={{
                            alignItems: 'center',
                            background: 'white',
                            display: 'flex',
                            justifyContent: 'right',
                            width: '100%',
                        }}
                        >
                            {os === 'ios' && isBrowserSafari && (
                                <ArrowIcon sx={{
                                    animation: `${bouncing} 1.5s ease-in-out infinite`,
                                    height: '36px',
                                    width: '28px',
                                }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '31px',
                        mt: '90px',
                        textAlign: 'center',
                    }} xs={12}
                    >
                        <QerkoLogoIcon sx={{ height: '36px', width: '120px' }} />
                        <Typography sx={{
                            fontFamily: 'Space Grotesk',
                            fontSize: '24px',
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            letterSpacing: '-0.4px',
                            lineHeight: '32px',
                            textAlign: 'center',
                        }}
                        >
                            {os === 'ios' && isBrowserSafari ? t('continue') : t('downloadApp')}
                        </Typography>
                        {os === 'ios' && (
                            <Typography sx={{
                                color: '#2D2533',
                                fontFamily: 'Space Grotesk',
                                fontFeatureSettings: '\'liga\' off',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: 'normal',
                                letterSpacing: '0.2px',
                                lineHeight: '24px',
                                textAlign: 'center',
                            }}
                            >
                                {t('download')}
                            </Typography>
                        )}
                        {os === 'ios' && (
                            <Link href={urlIosStore ? urlIosStore : 'https://itunes.apple.com/app/id1363182258?pt=118990682'} rel="noopener" target="_blank">
                                <AppleStoreIcon sx={{ fill: 'black', height: '40px', width: '132px' }} />
                            </Link>
                        )}
                        {os === 'android' && (
                            <Link href="https://play.google.com/store/apps/details?id=com.itispaid&launch=true" rel="noopener" target="_blank">
                                <GoogleStoreIcon sx={{ height: '60px', width: '148px' }} />
                            </Link>
                        )}
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};
